import { Grid } from '@material-ui/core'
import React from 'react'
import PrimaryButton from './PrimaryButton'

function IconButton({ classes, icon, children, ...props }) {
  const Icon = icon

  return (
    <PrimaryButton style={{ width: '100%' }} {...props}>
      <Grid container>
        <Grid item xs={12}>
          <Icon style={{ fontSize: '64px' }} />
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </PrimaryButton>
  )
}

export default (IconButton)